import React, { useEffect, useState } from 'react';
import { Warehouse } from '../internal/common.types';
import { WarehouseETADisplayTextEmea } from './WarehouseETADisplayTextEmea';

type Props = {
  'data-testid'?: string;
  fromPage: string;
  fromPageForETA?: string | null;
  licenseSelectorVendorSubrange?: string;
  preOrderEtaStockDetails?: any;
  reserveFlag: boolean;
  reserveQuantityStock: number;
  showWarehousePopupflag: boolean;
  siteCode: string;
  sku: string;
  skuType?: string;
  stockStatus: any;
  totalAvailableStock: number;
  vendorCode?: string;
  warehouseStockDetail: any;
  warehouses?: Warehouse[];
};

export function WarehouseETAComponentEmea(props: Props) {
  const {
    fromPage,
    fromPageForETA,
    licenseSelectorVendorSubrange,
    preOrderEtaStockDetails,
    reserveFlag,
    reserveQuantityStock,
    showWarehousePopupflag,
    sku,
    skuType,
    stockStatus,
    totalAvailableStock,
    vendorCode,
    warehouseStockDetail,
    warehouses,
  } = props;

  const [displayCentralFlag, setDisplayCentralFlag] = useState(false);
  const [displayLocalFlag, setDisplayLocalFlag] = useState(false);
  const [displayOutOfStockFlag, setDisplayOutOfStockFlag] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [stockStatusUpdate, setStockStatusUpdate] = useState(stockStatus);
  const [reserveStatusUpdate, setreserveStatusUpdate] = useState(reserveFlag);
  const [etaEllipsis, setEtaEllipsis] = useState(false);

  function getNum(val: any) {
    if (isNaN(val)) {
      return 0;
    }
    return val;
  }

  const etaLocalStock =
    preOrderEtaStockDetails !== null &&
    preOrderEtaStockDetails !== undefined &&
    preOrderEtaStockDetails?.reduce(
      (acc: any, cur: any) =>
        cur.stockType?.toUpperCase() === 'INSTOCK' &&
        cur.quantity > 0 &&
        cur.extendedStrings?.includes('WarehouseLocation-Local')
          ? acc + cur.quantity
          : acc,
      0
    );

  const etaLocalStockleadDaysLowerBoundary =
    (preOrderEtaStockDetails !== null &&
      preOrderEtaStockDetails !== undefined &&
      preOrderEtaStockDetails?.reduce(
        (acc: any, cur: any) =>
          cur.stockType?.toUpperCase() === 'INSTOCK' &&
          (cur.quantity > 0 || cur.reservedQuantity > 0) &&
          cur.extendedStrings?.includes('WarehouseLocation-Local')
            ? cur.leadDaysLowerBoundary
            : acc,
        0
      )) ??
    0;

  const etaLocalStockleadDaysUpperBoundary =
    (preOrderEtaStockDetails !== null &&
      preOrderEtaStockDetails !== undefined &&
      preOrderEtaStockDetails?.reduce(
        (acc: any, cur: any) =>
          cur.stockType?.toUpperCase() === 'INSTOCK' &&
          (cur.quantity > 0 || cur.reservedQuantity > 0) &&
          cur.extendedStrings?.includes('WarehouseLocation-Local')
            ? cur.leadDaysUpperBoundary
            : acc,
        0
      )) ??
    0;

  const etaCentralStock =
    preOrderEtaStockDetails !== null &&
    preOrderEtaStockDetails !== undefined &&
    preOrderEtaStockDetails?.reduce(
      (acc: any, cur: any) =>
        cur.stockType?.toUpperCase() === 'INSTOCK' &&
        cur.quantity > 0 &&
        cur.extendedStrings?.includes('WarehouseLocation-Central')
          ? acc + cur.quantity
          : acc,
      0
    );

  const etaCentralStockleadDaysLowerBoundary =
    preOrderEtaStockDetails !== null &&
    preOrderEtaStockDetails !== undefined &&
    preOrderEtaStockDetails?.reduce(
      (acc: any, cur: any) =>
        cur.stockType?.toUpperCase() === 'INSTOCK' &&
        cur.quantity > 0 &&
        cur.extendedStrings?.includes('WarehouseLocation-Central')
          ? cur.leadDaysLowerBoundary
          : acc,
      0
    );

  const etaCentralStockleadDaysUpperBoundary =
    preOrderEtaStockDetails !== null &&
    preOrderEtaStockDetails !== undefined &&
    preOrderEtaStockDetails?.reduce(
      (acc: any, cur: any) =>
        cur.stockType?.toUpperCase() === 'INSTOCK' &&
        cur.quantity > 0 &&
        cur.extendedStrings?.includes('WarehouseLocation-Central')
          ? cur.leadDaysUpperBoundary
          : acc,
      0
    );

  const etaOnOrder =
    preOrderEtaStockDetails !== null &&
    preOrderEtaStockDetails !== undefined &&
    preOrderEtaStockDetails?.reduce(
      (acc: any, cur: any) =>
        cur.stockType?.toUpperCase() === 'ONORDER' ? acc + cur.quantity : acc,
      0
    );

  const etaReservedQuantity =
    (preOrderEtaStockDetails !== null &&
      preOrderEtaStockDetails !== undefined &&
      preOrderEtaStockDetails?.reduce(
        (acc: any, cur: any) =>
          cur.stockType?.toUpperCase() === 'INSTOCK'
            ? getNum(acc) + getNum(cur.reservedQuantity)
            : acc ?? 0,
        0
      )) ??
    0;

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
    }

    if (etaLocalStock > 0) setDisplayLocalFlag(true);
    if (etaCentralStock > 0) setDisplayCentralFlag(true);
    if (etaReservedQuantity > 0) setreserveStatusUpdate(true);

    if (
      etaLocalStock <= 0 &&
      etaCentralStock <= 0 &&
      (Number(etaReservedQuantity ?? 0) <= 0 || isNaN(etaReservedQuantity)) &&
      etaOnOrder <= 0 &&
      (stockStatus?.toUpperCase() === 'OUTOFSTOCK' ||
        (stockStatus?.toUpperCase() === 'STOCKABLE' &&
          totalAvailableStock === 0))
    ) {
      setDisplayOutOfStockFlag(true);
      setStockStatusUpdate(fromPage === 'cart' ? 'OutOfStock' : 'Outofstock');
    }

    if (
      etaLocalStock <= 0 &&
      etaCentralStock <= 0 &&
      etaOnOrder > 0 &&
      (stockStatus?.toUpperCase() === 'INSTOCK' ||
        stockStatus?.toUpperCase() === 'OUTOFSTOCK' ||
        stockStatus?.toUpperCase() === 'STOCKABLE')
    ) {
      setDisplayOutOfStockFlag(true);
      setStockStatusUpdate(fromPage === 'cart' ? 'OutOfStock' : 'Outofstock');
    }

    if (
      etaLocalStock <= 0 &&
      etaCentralStock <= 0 &&
      (Number(etaReservedQuantity) <= 0 || isNaN(etaReservedQuantity)) &&
      (stockStatus?.toUpperCase() === 'INSTOCK' ||
        stockStatus?.toUpperCase() === 'OUTOFSTOCK' ||
        stockStatus?.toUpperCase() === 'STOCKABLE')
    ) {
      setDisplayOutOfStockFlag(true);
      setStockStatusUpdate(fromPage === 'cart' ? 'OutOfStock' : 'Outofstock');
    }

    if (
      fromPage?.toLowerCase() === 'cart' &&
      stockStatusUpdate?.toUpperCase() === 'DOWNLOADABLE'
    ) {
      setStockStatusUpdate('Download');
    }
    if (
      fromPage?.toLowerCase() === 'cart' &&
      stockStatusUpdate?.toUpperCase() === 'WARRANTY'
    ) {
      setStockStatusUpdate('Warranty');
    }
    if (
      fromPage?.toLowerCase() === 'cart' &&
      stockStatusUpdate?.toUpperCase() === 'LICENSE'
    ) {
      setStockStatusUpdate('License');
    }
    if (
      fromPage?.toLowerCase() === 'cart' &&
      stockStatusUpdate?.toUpperCase() === 'SERVICE'
    ) {
      setStockStatusUpdate('Service');
    }

    if (totalAvailableStock === 9999999) {
      fromPage?.toLowerCase() === 'cart'
        ? setStockStatusUpdate('Warranty')
        : setStockStatusUpdate('Available');
      setDisplayOutOfStockFlag(false);
    }

    if (
      fromPageForETA?.toLowerCase() === 'productgrid' ||
      fromPageForETA?.toLowerCase() === 'grid'
    ) {
      setEtaEllipsis(true);
    }
  }, [
    etaCentralStock,
    etaLocalStock,
    etaOnOrder,
    etaReservedQuantity,
    fromPage,
    fromPageForETA,
    isInitialRender,
    skuType,
    reserveQuantityStock,
    reserveStatusUpdate,
    stockStatus,
    stockStatusUpdate,
    totalAvailableStock,
  ]);

  return (
    <>
      <WarehouseETADisplayTextEmea
        centralStock={etaCentralStock}
        displayCentralFlag={displayCentralFlag}
        displayLocalFlag={displayLocalFlag}
        displayOutOfStockFlag={displayOutOfStockFlag}
        etaCentralStockleadDaysLowerBoundary={
          etaCentralStockleadDaysLowerBoundary
        }
        etaCentralStockleadDaysUpperBoundary={
          etaCentralStockleadDaysUpperBoundary
        }
        etaEllipsis={etaEllipsis}
        etaLocalStockleadDaysLowerBoundary={etaLocalStockleadDaysLowerBoundary}
        etaLocalStockleadDaysUpperBoundary={etaLocalStockleadDaysUpperBoundary}
        fromPage={fromPage}
        licenseSelectorVendorSubrange={licenseSelectorVendorSubrange}
        localStock={etaLocalStock + getNum(etaReservedQuantity)}
        onOrder={etaOnOrder}
        preOrderEtaStockDetails={preOrderEtaStockDetails}
        reserveFlag={reserveStatusUpdate}
        reservedStock={getNum(etaReservedQuantity)}
        showWarehousePopupflag={showWarehousePopupflag}
        sku={sku}
        skuType={skuType}
        stockStatus={stockStatusUpdate}
        totalAvailableStock={totalAvailableStock}
        vendorCode={vendorCode}
        warehouseStockDetail={warehouseStockDetail}
        warehouses={warehouses}
      ></WarehouseETADisplayTextEmea>
    </>
  );
}
